import { Action } from '@ngrx/store';
import * as commercialLicenseMappingsTypes from './commercial-license-mappings.types'
import { CommercialLicenseMapping } from './commercial-license-mappings.interface';


export class FetchCommercialLicenseMappingsRequest implements Action {
    readonly type = commercialLicenseMappingsTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_REQUEST;
    constructor(public payload: any = {}) { }
}


export class FetchCommercialLicenseMappingsSuccess implements Action {
    readonly type = commercialLicenseMappingsTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS;
    constructor(public payload: CommercialLicenseMapping[]) { }
}


export class FetchCommercialLicenseMappingsFailure implements Action {
    readonly type = commercialLicenseMappingsTypes.FETCH_COMMERCIAL_LICENSE_MAPPINGS_FAILURE;
    constructor(public payload: any) { }
}

export class FetchCommercialLicenseMappingRequest implements Action {
    readonly type = commercialLicenseMappingsTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_REQUEST;
    constructor(public id: number) { }
}


export class FetchCommercialLicenseMappingSuccess implements Action {
    readonly type = commercialLicenseMappingsTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_SUCCESS;
    constructor(public payload: CommercialLicenseMapping) { }
}


export class FetchCommercialLicenseMappingFailure implements Action {
    readonly type = commercialLicenseMappingsTypes.FETCH_COMMERCIAL_LICENSE_MAPPING_FAILURE;
    constructor(public payload: any) { }
}


export class DeleteCommercialLicenseMappingRequest implements Action {
    readonly type = commercialLicenseMappingsTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_REQUEST;
    constructor(public id: number) { }
}

export class DeleteCommercialLicenseMappingSuccess implements Action {
    readonly type = commercialLicenseMappingsTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_SUCCESS;
    constructor() { }
}


export class DeleteCommercialLicenseMappingFailure implements Action {
    readonly type = commercialLicenseMappingsTypes.DELETE_COMMERCIAL_LICENSE_MAPPING_FAILURE;
    constructor(public payload: any) { }
}

export class CreateCommercialLicenseMappingRequest implements Action {
    readonly type = commercialLicenseMappingsTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_REQUEST;
    constructor(public payload) { }
}

export class CreateCommercialLicenseMappingSuccess implements Action {
    readonly type = commercialLicenseMappingsTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS;
    constructor() { }
}


export class CreateCommercialLicenseMappingFailure implements Action {
    readonly type = commercialLicenseMappingsTypes.CREATE_COMMERCIAL_LICENSE_MAPPING_FAILURE;
    constructor(public payload: any) { }
}


export class UpdateCommercialLicenseMappingRequest implements Action {
    readonly type = commercialLicenseMappingsTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_REQUEST;
    constructor(public id: number, public payload) { }
}

export class UpdateCommercialLicenseMappingSuccess implements Action {
    readonly type = commercialLicenseMappingsTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_SUCCESS;
    constructor() { }
}


export class UpdateCommercialLicenseMappingFailure implements Action {
    readonly type = commercialLicenseMappingsTypes.UPDATE_COMMERCIAL_LICENSE_MAPPING_FAILURE;
    constructor(public payload: any) { }
}




export class OrderCommercialLicenseMappingRequest implements Action {
    readonly type = commercialLicenseMappingsTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_REQUEST;
    constructor(public id: number, public direction: string) { }
}

export class OrderCommercialLicenseMappingSuccess implements Action {
    readonly type = commercialLicenseMappingsTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_SUCCESS;
    constructor(public payload: any) { }
}


export class OrderCommercialLicenseMappingFailure implements Action {
    readonly type = commercialLicenseMappingsTypes.ORDER_COMMERCIAL_LICENSE_MAPPINGS_FAILURE;
    constructor(public payload: any) { }
}


// Common

export class UpdateField implements Action {
    readonly type = commercialLicenseMappingsTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = commercialLicenseMappingsTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions = UpdateCommercialLicenseMappingRequest | UpdateCommercialLicenseMappingSuccess | UpdateCommercialLicenseMappingFailure |
    FetchCommercialLicenseMappingsSuccess | FetchCommercialLicenseMappingsFailure | FetchCommercialLicenseMappingsRequest |
    FetchCommercialLicenseMappingSuccess | FetchCommercialLicenseMappingFailure | FetchCommercialLicenseMappingRequest |
    CreateCommercialLicenseMappingRequest | CreateCommercialLicenseMappingSuccess | CreateCommercialLicenseMappingFailure |
    DeleteCommercialLicenseMappingRequest | DeleteCommercialLicenseMappingSuccess | DeleteCommercialLicenseMappingFailure |
    SetDefaultData | UpdateField | FetchCommercialLicenseMappingsRequest |
    FetchCommercialLicenseMappingsSuccess | FetchCommercialLicenseMappingsFailure | OrderCommercialLicenseMappingRequest |
    OrderCommercialLicenseMappingSuccess |
    OrderCommercialLicenseMappingFailure;
